module.exports = __webpack_public_path__ + "img/rule1.b4559144.png";